import { render, staticRenderFns } from "./Herbal.vue?vue&type=template&id=5c13bebb&scoped=true"
import script from "./Herbal.vue?vue&type=script&lang=js"
export * from "./Herbal.vue?vue&type=script&lang=js"
import style0 from "./Herbal.vue?vue&type=style&index=0&id=5c13bebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13bebb",
  null
  
)

export default component.exports